import { DONT_SHOW_OPEN_SEATS_WARNING_AGAIN } from 'constants/user';
import { saveUserProperty } from 'redux/modules/user.actions';
import { getUserPropertyAsBoolean } from 'redux/selectors/user';
import type { Thunk } from 'types/redux';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/users-page');

export const dismissModalUnoccupiedSeatsModal = actionCreator('DISMISS_UNOCCUPIED_SEATS_MODAL');

export const showUnoccupiedSeatsModal = actionCreator('SHOW_UNOCCUPIED_SEATS_MODAL');

export const showUnoccupiedSeatsWarningModal = (): Thunk => (dispatch, getState) => {
  const state = getState();
  const dontShowAgain = getUserPropertyAsBoolean(state, DONT_SHOW_OPEN_SEATS_WARNING_AGAIN);
  if (dontShowAgain) {
    return;
  }
  dispatch(showUnoccupiedSeatsModal());
};

export const dismissUnoccupiedSeatsWarningModal =
  (options: { dontShowAgain: boolean }): Thunk =>
  dispatch => {
    dispatch(dismissModalUnoccupiedSeatsModal());
    dispatch(saveUserProperty(DONT_SHOW_OPEN_SEATS_WARNING_AGAIN, options.dontShowAgain));
  };
